import store from '@/store';

/**
 * 会话清理工具
 * 用于退出登录和登录前清理旧会话数据
 * 注意：不清理 IndexedDB 业务缓存（商品、店铺等离线数据）
 */

// localStorage 中需要清理的会话相关 key
const SESSION_KEYS = [
  // 认证相关
  'token',
  'userId',
  'uid',
  'userinfo',
  'uname',
  'psw',
  'id',
  'userPermissions',
  
  // 店铺相关
  'storeId',
  'currentStoreId',
  'userStoreId',
  'lockStoreId',
  'viewStoreId',
  'type',
  
  // 订单/购物车相关
  'orderData',
  'payInfo',
  'last_path',
  'last_query',
  'last_params',
  'scanErrorMessage',
  'checkoutReceiptType',
  'cartItems',
  'selectedCartItems',
  'checkoutData',
  'resourceOrderIds',
  
  // 业务临时数据
  'productStockFilter',
  'vconsole_enabled',
  'swiperNum',
  'contactJoinQuery',
  'addNotepadTempData',
  'templateLibraryId',
  'typeName',
  'typeid',
  'up',
];

/**
 * 清理 localStorage 中的会话数据
 */
export function clearLocalStorageSession() {
  SESSION_KEYS.forEach((key) => {
    localStorage.removeItem(key);
  });
}

/**
 * 清理 sessionStorage
 */
export function clearSessionStorage() {
  sessionStorage.clear();
}

/**
 * 重置 Vuex store 状态
 */
export function resetVuexState() {
  // 重置用户相关状态
  store.commit('SET_USER_ID', 0);
  store.commit('SET_USER_INFO', undefined);
  store.commit('SET_STORE_ID', null);
  
  // 重置权限相关状态
  store.commit('CLEAR_PERMISSIONS');
  store.commit('SET_STORE_USER', {});
  
  // 重置订单相关状态
  store.commit('CLEAR_ORDER_DATA');
  store.commit('SET_PAY_INFO', {});
  
  // 重置其他状态
  store.commit('SET_SHOP_CART_NUM', 0);
  store.commit('SET_PRODUCT_STOCK_FILTER', 'all');
}

/**
 * 清理 IndexedDB 中的用户数据表
 * 保留业务缓存（products、storeArr等）用于离线功能
 */
function clearIndexedDBUserData() {
  return new Promise((resolve) => {
    try {
      const request = indexedDB.open('tts', 1);
      
      request.onsuccess = (event) => {
        const db = event.target.result;
        
        // 清理 user 表（存储登录用户信息）
        if (db.objectStoreNames.contains('user')) {
          try {
            const transaction = db.transaction(['user'], 'readwrite');
            const store = transaction.objectStore('user');
            const clearRequest = store.clear();
            
            clearRequest.onsuccess = () => {
              console.log('[IndexedDB] user 表已清理');
              db.close();
              resolve();
            };
            
            clearRequest.onerror = () => {
              console.warn('[IndexedDB] user 表清理失败');
              db.close();
              resolve();
            };
          } catch (e) {
            console.warn('[IndexedDB] 清理 user 表异常:', e);
            db.close();
            resolve();
          }
        } else {
          db.close();
          resolve();
        }
      };
      
      request.onerror = () => {
        console.warn('[IndexedDB] 打开数据库失败');
        resolve();
      };
    } catch (e) {
      console.warn('[IndexedDB] 清理异常:', e);
      resolve();
    }
  });
}

/**
 * 完整的会话清理（退出登录时调用）
 */
export async function clearSession() {
  clearLocalStorageSession();
  clearSessionStorage();
  resetVuexState();
  
  // 清理 IndexedDB 用户数据（异步，不阻塞主流程）
  clearIndexedDBUserData().catch(() => {});
  
  console.log('[Session] 会话数据已清理');
}

/**
 * 登录前清理（登录时调用）
 * 确保登录前是干净的会话状态
 */
export function clearSessionBeforeLogin() {
  clearSession();
  console.log('[Session] 登录前清理完成');
}



// WEBPACK FOOTER //
// ./src/utils/session.js